var render = function () {
  var _vm$campaign$name;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Banner',
        to: {
          name: 'banner'
        }
      }, {
        label: this.bannerName
      }],
      "title": this.bannerName
    }
  }), _c('div', {
    staticClass: "bg-white p-4 my-3 rounded-lg shadow-sm"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('h2', {
    staticClass: "font-bold text-lg mb-3"
  }, [_vm._v("General Information")]), _c('router-link', {
    staticClass: "bg-blue-700 flex justify-start items-center rounded-lg py-2 px-2.5 text-white",
    attrs: {
      "to": {
        path: '/banner-edit/' + _vm.item_id
      }
    }
  }, [_c('svg', {
    staticClass: "w-6 h-6 text-white dark:text-white",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "currentColor",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z",
      "clip-rule": "evenodd"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v(" Edit Detail ")])], 1), _c('div', {
    staticClass: "grid grid-cols-2 gap-4"
  }, [_c('div', {
    staticClass: "flex-col"
  }, [_c('div', {
    staticClass: "w-full"
  }, [_c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("Banner Name")]), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v(_vm._s(this.bannerName))])]), _c('div', {
    staticClass: "flex justify-start items-start"
  }, [_c('div', {
    staticClass: "w-full"
  }, [_c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("Start Date")]), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v(_vm._s(_vm.formatDateStartAndEnd(this.valid_from)))])]), _c('div', {
    staticClass: "w-full"
  }, [_c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("End Date")]), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v(_vm._s(_vm.formatDateStartAndEnd(this.valid_to)))])])]), _c('div', {
    staticClass: "w-full"
  }, [_c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("Platform")]), _c('p', {
    staticClass: "text-gray-500 w-max mt-1.5",
    class: _vm.platformClass(this.client)
  }, [_vm._v(" " + _vm._s(_vm.platform(this.client)) + " ")])]), _vm._m(0), _c('div', {
    staticClass: "mt-1.5"
  }, [_c('img', {
    staticClass: "max-w-xs object-cover rounded-lg",
    staticStyle: {
      "height": "144px"
    },
    attrs: {
      "src": this.imgItem,
      "alt": "Banner Image"
    }
  })])]), _c('div', {
    staticClass: "w-full"
  }, [_c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("Created Date")]), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v(_vm._s(_vm.formatDate(this.created)))]), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("Last Modified")]), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v(_vm._s(_vm.formatDate(this.modified)))])])])]), _c('div', {
    staticClass: "bg-white p-4 my-3 rounded-lg shadow-sm"
  }, [_c('h2', {
    staticClass: "font-bold text-lg mb-3"
  }, [_vm._v("Banner’s Detail")]), _c('div', {
    staticClass: "grid grid-cols-2 gap-4 items-start"
  }, [_c('div', [_c('div', {
    staticClass: "w-full flex-col mb-3"
  }, [_c('p', {
    staticClass: "font-semibold mb-1"
  }, [_vm._v("Banner Type")]), _c('span', {
    class: _vm.BannerTypeColor(this.banner_type)
  }, [_vm._v(_vm._s(this.banner_type))])]), _c('div', {
    staticClass: "w-full flex-col mb-3"
  }, [_c('p', {
    staticClass: "font-semibold mb-0"
  }, [_vm._v("Display Zone")]), _c('span', {
    staticClass: "text-gray-500"
  }, [_vm._v(" Display on " + _vm._s(this.displayZone) + " Page")])]), _c('div', {
    staticClass: "w-full flex-col mb-3"
  }, [_c('p', {
    staticClass: "font-semibold mb-0"
  }, [_vm._v("Display Price")]), _c('span', {
    staticClass: "text-gray-500 capitalize"
  }, [_vm._v(" Show " + _vm._s(this.showPrice) + " Price Only")])]), _c('div', {
    staticClass: "w-full flex-col mb-3"
  }, [_c('p', {
    staticClass: "font-semibold mb-0"
  }, [_vm._v("Sort Priority")]), _c('span', {
    staticClass: "text-gray-500 capitalize"
  }, [_vm._v(" " + _vm._s(this.sortPriority))])]), _c('div', {
    staticClass: "mt-0 mb-3"
  }, [_c('p', {
    staticClass: "font-semibold mb-1"
  }, [_vm._v("Banner Terms and Condition")]), _c('div', [_c('p', {
    staticClass: "text-sm mb-0 text-gray-500 overflow-hidden transition-all duration-300",
    class: _vm.showMore ? 'whitespace-normal' : 'truncate',
    staticStyle: {
      "line-height": "1.5rem"
    }
  }, [_vm._v(" " + _vm._s(_vm.termAndCondition || '-') + " ")]), _vm.termAndCondition.length > 100 ? _c('button', {
    staticClass: "text-gray-700 text-sm mt-1 float-right focus:outline-none",
    on: {
      "click": _vm.toggleReadMore
    }
  }, [_vm._v(" " + _vm._s(_vm.showMore ? 'Read Less' : 'Read More') + " "), _c('i', {
    class: _vm.showMore ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'
  })]) : _vm._e()])])]), _c('div', [_c('div', {
    staticClass: "w-full flex-col mb-3"
  }, [_c('p', {
    staticClass: "font-semibold mb-0"
  }, [_vm._v("Campaign")]), _c('span', {
    staticClass: "text-gray-500 capitalize"
  }, [_vm._v(_vm._s((_vm$campaign$name = _vm.campaign.name) !== null && _vm$campaign$name !== void 0 ? _vm$campaign$name : _vm.campaign))])]), _c('div', {
    staticClass: "w-full flex-col mb-3"
  }, [_c('p', {
    staticClass: "font-semibold mb-0"
  }, [_vm._v("Notification Title")]), _c('span', {
    staticClass: "text-gray-500 capitalize"
  }, [_vm._v(" " + _vm._s(_vm.notificationTitle || '-') + " ")])]), _c('div', {
    staticClass: "w-full flex-col mb-3"
  }, [_c('p', {
    staticClass: "font-semibold mb-0"
  }, [_vm._v("Notification Display Date")]), _c('span', {
    staticClass: "text-gray-500 capitalize"
  }, [_vm._v(" " + _vm._s(_vm.formatDateStartAndEnd(_vm.notificationDisplayDate)) + " ")])]), _c('div', {
    staticClass: "mt-0 mb-3"
  }, [_c('p', {
    staticClass: "font-semibold mb-0"
  }, [_vm._v("Notification Content")]), _c('p', {
    staticClass: "text-sm mb-2 text-gray-500"
  }, [_vm._v(_vm._s(_vm.notificationContent || '-'))])])])])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("Banner Image")])]);
}]

export { render, staticRenderFns }